import i18n from '@/lib/i18n'
import { COUNTRIES_CONFIG } from '@/config/countries'

export function getCountryName(code: string): string {
  return COUNTRIES_CONFIG[code.toUpperCase()]?.name ?? code
}

export function getTranslatedCountryName(code: string): string {
  const t = i18n.getFixedT('en', 'common')
  return t(`countries.${code.toUpperCase()}`)
}

export function countryToSlug(code: string): string {
  const name = getCountryName(code)
  return name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')
}

export function slugToCountryCode(slug: string): string | null {
  const entry = Object.keys(COUNTRIES_CONFIG).find(code => countryToSlug(code) === slug)
  return entry ?? null
}
